import React from 'react';
import Loadable from 'react-loadable';

import LoadingState from './components/LoadingState/LoadingState';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "SportsHomeInPlayWidget" */ './SportsHomeInPlayWidget'),
  modules: ['./SportsHomeInPlayWidget'],
  loading: () => <LoadingState />
});

export default LoadableWidget;
